import React, { useEffect, useState } from 'react';
import { formatSeoApiError, listAuditLogs } from '../../../utils/adminSeo';

export default function SeoLogsScreen() {
  const [logs, setLogs] = useState([]);
  const [err, setErr] = useState('');
  useEffect(() => {
    setErr('');
    listAuditLogs({ limit: 50 })
      .then((r) => setLogs(r.logs || []))
      .catch((e) => setErr(formatSeoApiError(e)));
  }, []);
  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold text-[#1B375B]">Logs & Monitoring</h2>
      {err && <p className="text-red-600 text-sm">{err}</p>}
      <div className="bg-white border rounded overflow-x-auto max-h-[70vh]">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 sticky top-0">
            <tr>
              <th className="p-2 text-left">Time</th>
              <th className="p-2">Action</th>
              <th className="p-2">Status</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((l) => (
              <tr key={l.id} className="border-t">
                <td className="p-2 text-xs">{String(l.timestamp || '').slice(0, 19)}</td>
                <td className="p-2">{l.action}</td>
                <td className="p-2">{l.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {logs.length === 0 && <p className="p-4 text-gray-500 text-sm">No audit logs yet.</p>}
      </div>
    </div>
  );
}
